(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pdp-rating-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();

    function scrollToReviews() {
      requestAnimationFrame(function () {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    var jump = new CustomEvent('tenzen:pdp-review-jump', {
      cancelable: true,
      detail: { scroll: scrollToReviews }
    });
    if (window.dispatchEvent(jump)) scrollToReviews();
  });
}());
